import SlideFrame from "./_SlideFrame";
import { CheckCircle2 } from "lucide-react";

const pillars = [
  {
    k: "Program build · from nothing",
    v: "Our servicing leads — Jamie, Senga, and Colin — previously designed and stood up a full consumer-servicing program from launch: operating model, policies & procedures, vendor stack, call-center ops, collections workflow, reporting packages, and investor/compliance reporting.",
  },
  {
    k: "End-to-end ownership",
    v: "Performing servicing, default / non-performing servicing, and the full compliance framework — all built and run under their joint oversight. No outsourced template, no legacy playbook.",
  },
  {
    k: "Proven below industry norms",
    v: "In their prior program, the team consistently delivered default rates below published industry benchmarks (TransUnion 60+ DPD ~4.0–4.5% for unsecured consumer).",
  },
  {
    k: "Multi-hundred-million-dollar scale",
    v: "The team has led the servicing of unsecured consumer portfolios well into the hundreds of millions of dollars of originated volume — through multiple vintages and economic cycles.",
  },
];

export default function SlideTrackRecord() {
  return (
    <SlideFrame tag="05 · Proof">
      <div className="mb-10 max-w-5xl">
        <p className="overline mb-4">Operator track record</p>
        <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.9] font-medium">
          Expertise built at <em className="italic text-primary">institutional scale</em>.
        </h2>
        <p className="mt-5 text-foreground/75 max-w-3xl leading-relaxed">
          Our servicing leads have spent years building and running one of the most scrutinized
          unsecured-consumer servicing programs in the market. That&rsquo;s the discipline they bring to
          every partner portfolio IBA Servicing boards.
        </p>
      </div>

      {/* Headline stats */}
      <div className="grid md:grid-cols-3 gap-px bg-foreground/20 border border-foreground/20 mb-10">
        <div className="bg-background p-8">
          <p className="overline mb-3">Scale of programs led</p>
          <p className="font-mono-data text-6xl md:text-7xl tabular leading-none">
            $100M<span className="text-4xl">s</span>
          </p>
          <p className="mt-3 text-sm text-muted-foreground">
            Hundreds of millions of dollars of originated unsecured consumer volume serviced
          </p>
        </div>
        <div className="bg-background p-8 border-t-2 border-t-primary">
          <p className="overline mb-3">Default performance</p>
          <p className="font-mono-data text-6xl md:text-7xl tabular leading-none text-foreground">
            &lt; Industry
          </p>
          <p className="mt-3 text-sm text-muted-foreground">
            vs. TransUnion 60+ DPD benchmark of <span className="font-mono-data">4.0–4.5%</span> for unsecured consumer
          </p>
        </div>
        <div className="bg-background p-8">
          <p className="overline mb-3">Scope of work owned</p>
          <p className="font-mono-data text-6xl md:text-7xl tabular leading-none">End-to-end</p>
          <p className="mt-3 text-sm text-muted-foreground">
            Performing, non-performing, call center, collections, and compliance — all under one roof
          </p>
        </div>
      </div>

      {/* Pillars */}
      <div className="grid md:grid-cols-2 gap-px bg-foreground/20 border border-foreground/20">
        {pillars.map((p, i) => (
          <div key={i} className="bg-white p-7 md:p-8">
            <div className="flex items-center gap-3 mb-3">
              <CheckCircle2 className="w-4 h-4 text-primary" strokeWidth={1.75} />
              <span className="overline">{p.k}</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground/85">{p.v}</p>
          </div>
        ))}
      </div>

      {/* Economic implication */}
      <div className="mt-10 bg-muted border-l-4 border-primary px-8 py-6">
        <p className="overline mb-2">What this is worth to you · illustrative</p>
        <p className="font-display text-2xl md:text-3xl leading-snug text-foreground/90">
          Every <span className="font-mono-data">100&nbsp;bps</span> of charge-off reduction on a $500M portfolio ≈ <em className="italic text-primary">$5M of avoided annual loss</em>.
        </p>
        <p className="mt-3 text-sm text-muted-foreground">
          Low-default outcomes historically track with disciplined collections, tight underwriting
          feedback loops, and compliance rigor — the exact muscle our leads have built.
        </p>
      </div>
    </SlideFrame>
  );
}
